// needed for async await
import regeneratorRuntime from "regenerator-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { object, string } from 'yup';
import searchIcon from "../../../../../assets/images/svg/search-icon.svg";

const validationSchema = object().shape({
    zipcode: string().required()
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(5, 'Must be exactly 5 digits')
        .max(5, 'Must be exactly 5 digits')
});

const borderColor = (props) => {
  if (props.error) {
    return '#FF595C'
  } else if (props.name === 'teacher-listing') {
    return '#a0aec0'
  } else {
    return '#fff'
  }
}

const Input = styled.input.attrs({
    className: "bg-white text-black p-3 rounded-2xl border-1 h-full w-full focus:outline-none"
})`
  // adds prop for border color
  border-color: ${props => borderColor(props)};

  // removes webkit up/down arrows from input field where type = number
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
`;


/**
 *  Zip Code input field with validation
 * @param {string} name // required
 * @param {string} zipcode // optional
 * @param {func} onChange // optional
 */
const Zipcode = ({
                     name,
                     onChange,
                     showIcon,
                     zipcode
                 }) => {

    const [error, setError] = useState(null);
    const [_zipcode, setZipcode] = useState(zipcode);

    const handleChange = async ({ target: { value }}) => {
        let valid = false;
        try {
            valid = await validationSchema.validate({ zipcode: value });
            setError(null);
        } catch ({ errors }) {
            setError(errors);
        }

        if (valid) {
            setZipcode(value);
            if (onChange) onChange({ type: 'zipcode', value });
        } else {
            // restrict input value to 5
            setZipcode(value.slice(0, 5));
        }
    }

    return (
        <div className="relative flex">
            <Input
                error={ error }
                name={ name }
                value={ _zipcode }
                onChange={ handleChange }
                placeholder='Zip Code'
                type="number"
            />
            {showIcon && <img className="absolute self-center right-0 pr-2" src={ searchIcon } />}
        </div>
    )
}

Zipcode.propTypes = {
    onChange: PropTypes.func,
    zipcode: PropTypes.string
}

export default Zipcode;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Forms/Zipcode/index.jsx